import styled from 'styled-components';
import { breakpoint } from 'styles/globals';

const RankingListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  transition: all 0.25s;
  padding: 0px 16px;

  @media (${breakpoint.mdMin}) {
    column-gap: 24px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    padding: 0;
  }

  @media (${breakpoint.lgMin}) {
    column-gap: 24px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }

  @media (${breakpoint.xxlMin}) {
    column-gap: 48px;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
  }
`;

export default RankingListWrapper;
